"use strict";

module.exports = function (column) {
  var c = this.opts.columnsClasses;
  return c.hasOwnProperty(column) ? c[column] : '';
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/column-class.js
// module id = 1579
// module chunks = 64